import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { locationIdFormat } from "../ids";

const RedoFulfillmentToteGroupSchema_ = z.object({
  _id: zExt.objectId(),
  createdAt: z.date(),
  updatedAt: z.date(),
  team: zExt.objectId(),
  name: z.string(),
  locationId: locationIdFormat.schema.nullish(),
});
export const RedoFulfillmentToteGroupSchema: z.ZodType<RedoFulfillmentToteGroup> =
  RedoFulfillmentToteGroupSchema_;

export interface RedoFulfillmentToteGroup
  extends z.infer<typeof RedoFulfillmentToteGroupSchema_> {}
